import React, { useState } from 'react';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const EXAMPLE_CATALOG_NAME = 'becf-12017';

// The same loader snippet the integration demo embeds: it waits for the host page's load event before fetching the widget.
export const embedCodeFor = ({ widgetHost, identifier, catalogName }) => (
  `<div class="diecuttemplates_widget" data-id="${catalogName}"></div>
<script>
  (function(){
    var widgetId = "${identifier}";
    var w=window; var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.DieCutTemplates=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='${widgetHost}/js/quote_builder/' + widgetId + '.js';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}})();
</script>`
);

const domainWithHttp = (domain) => `https://${domain}`;

const InstallationSection = ({ widgetHost, identifier, domains, onSectionChange }) => {
  const [catalogName, setCatalogName] = useState(EXAMPLE_CATALOG_NAME);
  const [copiedTarget, setCopiedTarget] = useState(null);

  if (!identifier) {
    return (
      <div className={styles.fieldGroup}>
        <p className={styles.helpText}>{t('quote_builder_widget.installation_save_first')}</p>
      </div>
    );
  }

  const embedCode = embedCodeFor({ widgetHost, identifier, catalogName: catalogName.trim() || EXAMPLE_CATALOG_NAME });
  const domainList = domains.length > 0 ? domains.map(domainWithHttp).join(', ') : t('quote_builder_widget.installation_no_domains_short');

  const developerInstructions = t('quote_builder_widget.installation_developer_instructions', {
    embed_code: embedCode,
    domains: domainList,
    widget_host: widgetHost,
  });

  const copy = (text, target) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedTarget(target);
      setTimeout(() => setCopiedTarget(null), 2000);
    });
  };

  const mailtoHref = `mailto:?subject=${encodeURIComponent(t('quote_builder_widget.installation_email_subject'))}&body=${encodeURIComponent(developerInstructions)}`;

  return (
    <div>
      <div className={styles.fieldGroup}>
        <label className={styles.label}>{t('quote_builder_widget.installation_title')}</label>
        <p className={styles.helpText}>{t('quote_builder_widget.installation_info')}</p>
      </div>

      <div className={styles.fieldGroup}>
        <label className={styles.label}>{t('quote_builder_widget.installation_step_catalog_name')}</label>
        <p className={styles.helpText}>{t('quote_builder_widget.installation_step_catalog_name_info')}</p>
        <input
          type="text"
          className={`form-control ${styles.catalogNameInput}`}
          aria-label={t('quote_builder_widget.installation_step_catalog_name')}
          value={catalogName}
          placeholder={EXAMPLE_CATALOG_NAME}
          onChange={(event) => setCatalogName(event.target.value)}
        />
      </div>

      <div className={styles.fieldGroup}>
        <label className={styles.label}>{t('quote_builder_widget.installation_step_code')}</label>
        <p className={styles.helpText}>{t('quote_builder_widget.installation_step_code_info')}</p>
        <pre className={styles.embedCode} data-testid="embed-code">{embedCode}</pre>
        <button className="dct-button dct-button--primary dct-button--small" type="button" onClick={() => copy(embedCode, 'code')}>
          <i className={`fa ${copiedTarget === 'code' ? 'fa-check' : 'fa-clipboard'}`} aria-hidden="true"></i>{' '}
          {copiedTarget === 'code' ? t('quote_builder_widget.installation_copied') : t('quote_builder_widget.installation_copy_code')}
        </button>
      </div>

      <div className={styles.fieldGroup}>
        <label className={styles.label}>{t('quote_builder_widget.installation_step_domains')}</label>
        <p className={styles.helpText}>{t('quote_builder_widget.installation_step_domains_info')}</p>
        {domains.length > 0 ? (
          <ul className={styles.installationDomainList}>
            {domains.map((domain) => (
              <li key={domain} className={styles.domainDisplay}>{domainWithHttp(domain)}</li>
            ))}
          </ul>
        ) : (
          <p className={styles.installationWarning}>
            <i className="fa fa-exclamation-triangle" aria-hidden="true"></i> {t('quote_builder_widget.installation_no_domains')}{' '}
            <a href="#configuration" onClick={(event) => { event.preventDefault(); onSectionChange('configuration'); }}>
              {t('quote_builder_widget.section_configuration')}
            </a>
          </p>
        )}
      </div>

      <div className={styles.fieldGroup}>
        <label className={styles.label}>{t('quote_builder_widget.installation_developer')}</label>
        <p className={styles.helpText}>{t('quote_builder_widget.installation_developer_info')}</p>
        <div className={styles.installationActions}>
          <button className="dct-button dct-button--secondary dct-button--small" type="button" onClick={() => copy(developerInstructions, 'instructions')}>
            <i className={`fa ${copiedTarget === 'instructions' ? 'fa-check' : 'fa-clipboard'}`} aria-hidden="true"></i>{' '}
            {copiedTarget === 'instructions' ? t('quote_builder_widget.installation_copied') : t('quote_builder_widget.installation_copy_instructions')}
          </button>
          <a className="dct-button dct-button--secondary dct-button--small" href={mailtoHref}>
            <i className="fa fa-envelope-o" aria-hidden="true"></i> {t('quote_builder_widget.installation_email_instructions')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default InstallationSection;
